import React from 'react';

export default function HeroBlock({ content = {} }) {
  const bg = content.background_color || '#0F1923';
  const color = content.text_color || '#ffffff';

  return (
    <section
      className="w-full py-12 sm:py-16 px-4 sm:px-6"
      style={{ backgroundColor: bg, color }}
    >
      <div className="mx-auto text-center max-w-2xl">
        {content.logo_url && (
          <img
            src={content.logo_url}
            alt=""
            className="h-10 sm:h-12 mx-auto mb-6 object-contain"
          />
        )}
        {content.headline && (
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-tight mb-4">
            {content.headline}
          </h1>
        )}
        {content.subheadline && (
          <p className="text-base sm:text-lg opacity-90 leading-relaxed">
            {content.subheadline}
          </p>
        )}
      </div>
    </section>
  );
}
